import { useEffect, useState } from "react";

export function useWindowSize() {
  // Definindo um estado para armazenar a largura e altura da janela
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    // Função que atualiza o estado com o tamanho atual da janela
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // Adicionando o event listener para detectar mudanças no tamanho da janela
    window.addEventListener('resize', handleResize);

    // Limpando o event listener quando o componente for desmontado
    return () => window.removeEventListener('resize', handleResize);
  }, []); // O array vazio [] garante que o effect só execute uma vez após o primeiro render

  return windowSize;
}